import styled from 'styled-components';
import colours from 'theme/atoms/colours';

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 0 0 24px 0;
`;

export const Header = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  position: relative;
`;

export const Form = styled('div')`
  border-radius: 20px;
  background-color: white;
  border: 2px solid rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 20px 15px;
`;

export const FormGroup = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const StyledInput = styled('input')`
  background-color: white;
  border: 2px solid rgba(0, 0, 0, 0.05);
  border-radius: 30px;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  padding: 15px 15px 15px 20px;
  width: 100%;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: ${colours.primary[500]};
  }
`;

export const EmojiDisplay = styled('div')`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: ${colours.neutral[200]};
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(0, 0, 0, 0.05);
`;

export const NicknamesContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
`;

interface NicknameTagProps {
  $isDeleted?: boolean;
}

export const NicknameTag = styled('div')<NicknameTagProps>`
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 15px 17px 15px 20px;
  border-radius: 30px;
  border: 2px solid rgba(0, 0, 0, 0.05);
  opacity: ${(props) => (props.$isDeleted ? 0.5 : 1)};
  max-height: 50px;
  transition: opacity 0.2s;

  p {
    text-decoration: ${(props) => (props.$isDeleted ? 'line-through' : 'none')};
  }
`;

export const RemoveNicknameButton = styled('button')`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: black;
  width: 16px;
  height: 16px;
  flex-shrink: 0;

  &:hover {
    color: ${colours.neutral[800]};
  }
`;

export const AddNicknameButton = styled('button')`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 15px 17px 15px 20px;
  border: none;
  border-radius: 30px;
  max-height: 50px;
  cursor: pointer;
  color: black;

  &:hover {
    background-color: ${colours.neutral[100]};
  }
`;

export const EditableNicknameTag = styled('div')`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 20px;
  border: 1px solid black;
  background-color: white;
`;

export const EditableNicknameInput = styled('input')`
  border: none;
  outline: none;
  background: transparent;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: black;
  padding: 0;
  margin: 0;
  width: 120px;
  min-width: 80px;

  &::placeholder {
    color: ${colours.neutral[400]};
  }

  &:focus {
    outline: none;
  }
`;

export const LabelWithTooltip = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const InfoIconWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: black;
  transition: color 0.2s;
  border-radius: 4px;
  outline: none;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    color: ${colours.primary[500]};
  }

  &:focus-visible {
    color: ${colours.primary[500]};
    outline: 2px solid ${colours.primary[500]};
    outline-offset: 2px;
  }
`;
